import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Tooltip from "@material-ui/core/Tooltip";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AddItem from "./AddItem";
import ChartItem from "./Chart";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Redirect } from "react-router-dom";
import _ from "lodash";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
class ManageItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openItemBox: false,
      openChart: false,
      go_login: false,
      prices_disable_status: false,
      collapseId: null,
      drawerOpen: false,
      collapseOpen: false,
      expands: {}
    };
  }
  updateDimensions = () => {
    var w = window,
      d = document,
      documentElement = d.documentElement,
      body = d.getElementsByTagName("body")[0],
      width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
      height =
        w.innerHeight || documentElement.clientHeight || body.clientHeight;

    this.setState({ width: width, height: height });
    // if you are using ES2015 I'm pretty sure you can do this: this.setState({width, height});
  };
  componentWillMount() {
    this.updateDimensions();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    document.title = "مدیریت آیتم ها";
    this.setState({ editMode: false, name: "", price: "", unit: "" });
    this.props.socket !== null
      ? this.getData(this.props.socket)
      : console.log();
  }
  componentWillReceiveProps(nextProps) {
    nextProps.socket !== null ? this.getData(nextProps.socket) : console.log();

    this.setState({ editMode: false, name: "", price: "", unit: "" });
  }
  isValideToken = () => {};

  addCard = () => {
    this.setState({ openItemBox: true, editedMode: false });
  };
  editBox = (id, name, price, unit) => {
    this.setState({
      openItemBox: true,
      editedMode: true,
      name,
      price,
      unit,
      id
    });
  };
  addCardToList = (name, price, unit) => {
    const { socket } = this.props;
    const token = localStorage.getItem("token");
    socket.once("items_add", data => {
      if (!data.error) {
        this.setState({messageInfo:data.message , open:true,hasError:false})
        const { socket } = this.props;
        this.getData(socket);
      } else {
        this.setState({messageInfo:data.message , open:true , hasError:true})
      }
    });
    socket.emit("items_add", { name, price, unit, token });
  };
  closeBox = () => {
    this.setState({ openItemBox: false, openChart: false });
    this.setState({ editMode: false, name: "", price: "", unit: "" });
  };
  openChart = id => {
    this.setState({ openChart: true, selectedId: id });
  };
  getData = socket => {
    const token = localStorage.getItem("token");
    const { expands } = this.state;
    socket.once("items_list", data => {
      if (!data.error) {
        console.log(data);
        this.setState(prevState => ({
          item: data.data.items,
          connected: socket.connected,
          prices_disable_status: data.data.prices_disable_status,
          prices_disable_text: data.data.prices_disable_text,hasError:false
        }));

        this.setState({ go_login: false });
      } else if (data.message === "Invalid Token") {
        this.setState({ go_login: true });
      } else {
        this.setState({messageInfo:data.message , open:true,go_login:false , hasError:true})
      }
    });
    socket.emit("items_list", { token });
  };
  handleEdit = (id, name, price, unit) => {
    const { socket } = this.props;
    const token = localStorage.getItem("token");
    socket.once("items_update", data => {
      console.log(data);
      if (!data.error) {
        this.setState({messageInfo:data.message , open:true,hasError:false})
        const { socket } = this.props;
        this.getData(socket);
      } else {
        this.setState({messageInfo:data.message , open:true, hasError:true})
      }
    });
    socket.emit("items_update", { id, name, price, unit, token });
    this.setState({ editMode: false, name: "", price: "", unit: "" });
  };
  activeToggle = id => {
    const { socket } = this.props;
    const token = localStorage.getItem("token");
    socket.once("items_is_active", data => {
      if (!data.error) {
        this.setState({messageInfo:data.message , open:true,hasError:false })
        const { socket } = this.props;
        this.getData(socket);
      } else {
        this.setState({messageInfo:data.message , open:true , hasError:true})
      }
    });
    socket.emit("items_is_active", { id, token });
  };
  confirmRemove = id => {
    this.setState({ confirm_open: true, removeId: id });
  };
  dismiss = id => {
    this.setState({ confirm_open: false, removeId: null });
  };
  handleConfirmRemove = () => {
    const { socket } = this.props;
    const { removeId } = this.state;
    const token = localStorage.getItem("token");
    socket.once("items_delete", data => {
      if (!data.error) {
        this.setState({messageInfo:data.message , open:true,hasError:false})
        const { socket } = this.props;
        this.getData(socket);
      } else {
        this.setState({messageInfo:data.message , open:true , hasError:true})
      }
    });
    socket.emit("items_delete", { removeId, token });
    this.setState({ confirm_open: false, removeId: null });
  };
  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleChangechecked = () => {
    // this.setState({ prices_disable_status: !this.state.prices_disable_status },()=>{
    // })
    if (!this.state.prices_disable_status) {
      this.setState({ openDisable: true, prices_disable_status: true });
    } else {
      this.setState({ prices_disable_status: false }, () => {
        this.handleSendDisablePrices();
      });
    }
  };
  handleSendDisablePrices = () => {
    const { socket } = this.props;
    const { prices_disable_text, prices_disable_status } = this.state;
    const token = localStorage.getItem("token");
    this.setState({ openDisable: false });
    socket.once("prices_disable_update", data => {
      if (!data.error) {
        this.getData(socket);
        this.setState({ go_login: false });
        this.setState({messageInfo:data.message , open:true,hasError:false})
        //
      } else if (data.message === "Invalid Token") {
        this.setState({ go_login: true });
      } else {
        this.setState({ go_login: false });
        this.setState({messageInfo:data.message , open:true, hasError:true})
      }
    });
    console.log(prices_disable_text, prices_disable_status, token);
    socket.emit("prices_disable_update", {
      prices_disable_text,
      prices_disable_status,
      token
    });
  };
  dismissSendDisable = () => {
    this.setState({ openDisable: false });
    this.setState({ prices_disable_status: !this.state.prices_disable_status });
  };
  sendLastPrice = () => {
    const { socket } = this.props;
    const token = localStorage.getItem("token");
    socket.once("send_price", data => {
      if (!data.error) {
        this.setState({ go_login: false });
        this.setState({messageInfo:data.message , open:true ,hasError:false})
      } else if (data.message === "Invalid Token") {
        this.setState({ go_login: true });
      } else {
        this.setState({ go_login: false });
        this.setState({messageInfo:data.message , open:true , hasError:true})
      }
    });
    socket.emit("send_price", { token });
  };
  handleExpandClick = id => {
    const { collapseId } = this.state;
    collapseId === id
      ? this.setState({ collapseId: 0 })
      : this.setState({ collapseId: id });
  };
  handleClose = ()=>{
    this.setState({open:false});
  }
  render() {
    const {
      width,messageInfo,open,hasError,
      go_login,
      prices_disable_text,
      openDisable,
      openItemBox,
      prices_disable_status,
      editedMode,
      openChart,
      item,
      selectedId,
      name,
      price,
      unit,
      expands,
      id,
      confirm_open,
      disable_Price
    } = this.state;
    const itemInfo = {
      id,
      name,
      price,
      unit
    };

    return go_login ? (
      <Redirect to="/login?go-login=true" />
    ) : (
      <React.Fragment>
        <h1 className="h1 without-parent-padding">مدیریت آیتم ها</h1>
        <Card className="profile-card no-padding">
          <CardContent className="ap-tabpanel-wrapper">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={7} lg={10}>
                <div className="placeholer_tooltip">
                  <span style={{ color: "#656181" }}>
                    اطلاعات آیتم های مالی
                  </span>
                </div>
                <p style={{ fontSize: 14, color: "#656181" }}>
                  <span style={{ color: "#FF6565" }}>توجه: </span>
                  شما می توانید از این قسمت اطلاعات مالی خود را وارد ، ویرایش و
                  غیر فعال نمایید
                </p>
              </Grid>
              <Grid
                item
                className="operation-top-btns"
                xs={12}
                sm={12}
                md={5}
                lg={2}
                style={{ alignSelf: "flex-end", direction: "ltr" }}
              >
                <Button
                  variant="contained"
                  onClick={this.addCard}
                  color="primary"
                  className="save-btn"
                  style={{ marginBottom: "10px" }}
                >
                  افزودن آیتم
                  <i
                    className="fa fa-plus-circle"
                    style={{ marginLeft: 10 }}
                  ></i>
                </Button>
                <Button
                  variant="contained"
                  onClick={this.sendLastPrice}
                  color="primary"
                  className="save-btn"
                  style={{ marginBottom: "37px" }}
                >
                  ارسال آخرین قیمت
                </Button>
              </Grid>
            </Grid>
            <div className="items-list">
              <h4 className="title-modal">لیست آیتم ها </h4>
              <FormControlLabel
                className="disable-prices"
                label="غیر فعال کردن قیمت ها"
                control={
                  <Switch
                    checked={prices_disable_status ? true : false}
                    onChange={() => this.handleChangechecked()}
                    value={prices_disable_status}
                    color="primary"
                  />
                }
              />
              {width > 720 ? (
                <div className="table-responsive">
                  <Table className="ap-cancelation-table">
                    <TableHead>
                      <TableRow>
                        <TableCell>ردیف</TableCell>
                        <TableCell>نام</TableCell>
                        <TableCell>آخرین قیمت</TableCell>
                        <TableCell>آخرین بروز رسانی</TableCell>
                        <TableCell>گزارشات قیمت</TableCell>
                        <TableCell>عملیات</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {_.map(item, (row, index) => {
                        return (
                          <TableRow>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{row.name}</TableCell>
                            <TableCell>
                              {row.price} {row.unit}
                            </TableCell>
                            <TableCell>
                              {row.date} {row.time}
                            </TableCell>
                            <TableCell>
                              <i
                                onClick={() => this.openChart(row.id)}
                                className="far fa-chart-line item-chart"
                              ></i>
                            </TableCell>
                            <TableCell>
                              <i
                                onClick={() =>
                                  this.editBox(
                                    row.id,
                                    row.name,
                                    row.price,
                                    row.unit
                                  )
                                }
                                className="fal fa-edit edit-item"
                              ></i>
                              <i
                                onClick={() => this.activeToggle(row.id)}
                                className={`fa fa-${
                                  row.is_active
                                    ? "eye"
                                    : "eye-slash disable-item"
                                }`}
                              ></i>
                              <i
                                onClick={() => this.confirmRemove(row.id)}
                                class="far fa-times remove-item"
                              ></i>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              ) : (
                <ul className="responsive-item-list">
                  {_.map(item, (row, index) => {
                    return (
                      <li key={index}>
                        <Grid container>
                          <Grid item md={12} className="mb35">
                            <Card>
                              <CardContent>
                                <h4
                                  className="resp-item-title"
                                  onClick={() => this.handleExpandClick(row.id)}
                                >
                                  {index + 1} - {row.name}
                                  <IconButton aria-label="show more">
                                    <ExpandMoreIcon
                                      className={
                                        expands.custom_expand ? "active" : ""
                                      }
                                    />
                                  </IconButton>
                                </h4>
                              </CardContent>
                              <Collapse
                                in={
                                  this.state.collapseId === row.id
                                    ? true
                                    : false
                                }
                                timeout="auto"
                                unmountOnExit
                              >
                                <span className="res-item-price">
                                  <span className="row-name">آخرین قیمت:</span>
                                  {row.price} {row.unit}
                                </span>
                                <span className="res-item-date">
                                  <span className="row-name">
                                    {" "}
                                    آخرین بروز رسانی:
                                  </span>
                                  {row.date} {row.time}
                                </span>
                                <span className="res-item-chart">
                                  <span className="row-name">
                                    گزارشات قیمت :
                                  </span>
                                  <i
                                    onClick={() => this.openChart(row.id)}
                                    className="far fa-chart-line item-chart"
                                  ></i>
                                </span>
                                <span className="res-item-operation">
                                  <span className="row-name">عملیات:</span>
                                  <i
                                    onClick={() =>
                                      this.editBox(
                                        row.id,
                                        row.name,
                                        row.price,
                                        row.unit
                                      )
                                    }
                                    className="fal fa-edit edit-item"
                                  ></i>
                                  <i
                                    onClick={() => this.activeToggle(row.id)}
                                    className={`fa fa-${
                                      row.is_active
                                        ? "eye"
                                        : "eye-slash disable-item"
                                    }`}
                                  ></i>
                                  <i
                                    onClick={() => this.confirmRemove(row.id)}
                                    class="far fa-times remove-item"
                                  ></i>
                                </span>
                              </Collapse>
                            </Card>
                          </Grid>
                        </Grid>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </CardContent>
        </Card>
        <ChartItem
          openChart={openChart}
          id={selectedId}
          closeBox={this.closeBox}
        />
        <AddItem
          openBox={openItemBox}
          info={itemInfo}
          closeBox={this.closeBox}
          editedMode={editedMode}
          editItem={this.handleEdit}
          addItem={this.addCardToList}
        />
        {openDisable ? (
          <div className="disable-wrapper">
            <div className="disable-body">
              <h3 className="title">
                غیر فعال کردن قیمت
                <i class="far fa-times" onClick={this.dismissSendDisable}></i>
              </h3>
              <div className="disable-content">
                <h4 className="">متن خود را برای غیر فعال کردن وارد نمایید</h4>

                <input
                  type="text"
                  className="custom-text"
                  value={prices_disable_text}
                  name="prices_disable_text"
                  placeholder="متن ... "
                  onChange={this.handleChange}
                />
                <ul className="dialog-operations">
                  <li>
                    <Button
                      variant="contained"
                      onClick={this.dismissSendDisable}
                      className="dismiss-dalog "
                    >
                      انصراف
                    </Button>
                  </li>
                  <li>
                    <Button
                      variant="contained"
                      onClick={this.handleSendDisablePrices}
                      className="confirm-dalog confirm"
                    >
                      ارسال
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ) : null}

        <ToastContainer autoClose={3000} />
        {confirm_open ? (
          <div className="confirm-dialog">
            <div className="confirm-body">
              <p className="warning">از حذف این آیتم مطمئنید؟</p>
              <ul className="dialog-operations">
                <li>
                  <Button
                    variant="contained"
                    onClick={this.dismiss}
                    className="dismiss-dalog "
                  >
                    خیر،انصراف
                  </Button>
                </li>
                <li>
                  <Button
                    variant="contained"
                    onClick={this.handleConfirmRemove}
                    className="confirm-dalog remove"
                  >
                    بله،حذف شود
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        ) : null}
        <Snackbar
          key={messageInfo ? messageInfo : undefined}
          className={hasError?"error-msg":'success-msg' }
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={open}
          severity="success"
          autoHideDuration={6000}
          onClose={this.handleClose}
          onExited={this.handleExited}
          message={messageInfo ? messageInfo : undefined}
          action={
            <React.Fragment>
              <IconButton
                aria-label="close"
                color="inherit"
                onClick={this.handleClose}
              >
                <CloseIcon />
              </IconButton>
            </React.Fragment>
          }
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    socket: state.setSocket
  };
};
export default connect(mapStateToProps)(ManageItems);
